import React from 'react';
import { NoData } from '../TableList/style';

import reservationsImage from '../../assets/icons-no-found-data/COLOR/Nenhuma reserva 001.svg';
import dashboardImage from '../../assets/icons-no-found-data/COLOR/Dashboard 002.svg';
import magikeySmartlocksImage from '../../assets/icons-no-found-data/COLOR/Nenhuma fechadura.svg';
import accommodationsImage from '../../assets/icons-no-found-data/COLOR/Nenhuma acomodacao.svg';
import subscriptionImage from '../../assets/icons-no-found-data/COLOR/Nenhuma assinatura.svg';
import usersImage from '../../assets/icons-no-found-data/COLOR/Nenhum usuario 001.svg';
import defaultImage from '../../assets/icons-no-found-data/COLOR/Nenhum dado - Generico.svg';
    

import { Flex } from '@mantine/core';

export type moduleName = 'reservations' | 'dashboard' | 'magikeySmartlocks' | 'accommodations' | 'subscription' | 'users' | 'default' | 'contractModels';

interface NoFoundDataProps {
    message: string;
    moduleName: moduleName;
}

const moduleImages: Record<moduleName, {patch:string, size: string}> = {
    reservations: {patch: reservationsImage, size: '34vh'},
    dashboard: {patch: dashboardImage, size: '34vh'},
    magikeySmartlocks: {patch: magikeySmartlocksImage, size: '29vh'},
    accommodations: {patch: accommodationsImage, size: '34vh'},
    subscription: {patch: subscriptionImage, size: '34vh'},
    users: {patch: usersImage, size: '34vh'},
    default: {patch: defaultImage, size: '34vh'},
    contractModels: {patch: defaultImage, size: '24vh'},
};


const NoFoundData: React.FC<NoFoundDataProps> = ({ message, moduleName }) => {
    const imagePath = moduleImages[moduleName];

    return (
        <Flex direction='column' align='center' mt={moduleName === 'magikeySmartlocks' ? '15px': {}} h={moduleName !== 'magikeySmartlocks' ? '100%': {}} justify='center'>
            <img src={imagePath.patch} alt={moduleName} style={{ maxWidth: imagePath.size, marginBottom: '40px'}} />

            <NoData>{message}</NoData>
        </Flex>
    );
};

export default NoFoundData;